import React from 'react';
import Header from './Header';
import Footer from './Footer';
import Modals from '../components/Modals';
import useScrollToTop from '../hooks/useScrollToTop';

const Layout = ({ children }) => {
  useScrollToTop()
  return (
    <div>
      <Header />
      {children}
      <Footer />
      <Modals />
    </div>
  )
}

export default Layout;
